module.exports = __webpack_public_path__ + "static/kuba-ec5e7b0ce997d960339a306449764291.webp";